// Wraps Web Storage because even resolving the browser storage object can throw in restricted contexts.
const createSafeWebStorage = (storageName) => {
	const getStorage = () => window[storageName];

	return {
		getItem(key, fallback = null) {
			try {
				return getStorage().getItem(key) ?? fallback;
			} catch {
				return fallback;
			}
		},
		setItem(key, value) {
			try {
				getStorage().setItem(key, value);
				return true;
			} catch {
				return false;
			}
		},
		removeItem(key) {
			try {
				getStorage().removeItem(key);
				return true;
			} catch {
				return false;
			}
		},
		getJson(key, fallback = null) {
			try {
				const value = getStorage().getItem(key);
				return value === null ? fallback : JSON.parse(value);
			} catch {
				return fallback;
			}
		},
		setJson(key, value) {
			try {
				getStorage().setItem(key, JSON.stringify(value));
				return true;
			} catch {
				return false;
			}
		},
	};
};

export const safeLocalStorage = createSafeWebStorage('localStorage');
export const safeSessionStorage = createSafeWebStorage('sessionStorage');
